module.exports = __webpack_public_path__ + "static/media/gain_will.f16aa332.png";